<div class="d-grid">
  <strong>{{ 'portfolio.explanation' | translate }}</strong>
  <div #explanationArea class="border border-2 rounded me-2 mt-2 field-height">
    <p
      [gstarTextareaOverflowButton]="true"
      [fieldTitle]="transactionTypeName()"
      [innerHTML]="explanation() | blankLinks | safe: 'html'"
      [textContent]="explanation()"
      [htmlElement]="explanationArea"
      type="html"
      class="pt-2 p-1 text-muted pe-none m-0 white-space-pre font-family-georgia"></p>
  </div>
</div>
